window.AlpineSearch = function (vendor) {
  return {
    hidden: false,
    focused: false,
    search: ' ',
    delayed_search: '',
    filteredList: [],
    init: function () {
      var _this = this;
      fetch(window.vsvars.cdnurl + '/js/models.json?version='+window.vsvars.modelsjson_version).then(res => res.json()).then((completeList) => {
        if (vendor) {
          completeList = completeList.filter(function (v) {
            return v.v === vendor || v.v2 === vendor;
          });
        }
        completeList.forEach((v) => (v.s = (v.v + v.m + (v.v2 || "")).toLowerCase()))
        completeList.sort((a, b) => +b.p - +a.p)
        this.$watch('delayed_search', (delayed_search) => {
          statObj = vsGetStatObj();
          statObj.UserSearch = delayed_search;
          if (!vsIsLocal()) {
            vsJSONP("https://www.hamrick.com/d/v1/stat", null, statObj);
          }
        });
        this.$watch('search', (search) => {
          /** @type {string[]} */
          var searchItems = search.toLowerCase().split(' ')
          this.filteredList = completeList
            .filter(({ s }) => searchItems.every((v) => s.includes(v)))
            .slice(0, 10)
        });
        this.$watch('focused', (focused) => {
          if (focused) {
            this.$root.scrollIntoView({ behavior: "smooth" });
          }
        });
        this.hidden = false;
        this.search = ''
      }).catch(function(err) {
        _this.hidden = true;
      });
    },
    unfocus: function () {
      this.focused = false;
      this.$refs.searchinput.value = '';
      this.$refs.searchinput.blur(); // blur means unfocus
      this.search = '';
      this.delayed_search = '';
    },
    enterButtonClicked: function () {
      if (this.filteredList.length > 0)
        window.location = window.vsvars.baseurl + '/vuescan/' + this.filteredList[0].f;
    }
  }
};

const ReguModalStates = Object.freeze({
  Main: 1,
  Pending: 2,
  Complete: 3,
  ManualLicense: 4,
  ManualLicenseComplete: 5
});
window.ReguModalStates = ReguModalStates;
const ReguModalType = Object.freeze({
  Upgrade: 0,
  Update: 1
});
window.ReguModalType = ReguModalType;
window.AlpineReguEmailModal = function () {
  return {
    state: ReguModalStates.Main,
    type: ReguModalType.Upgrade,
    email: null,
    invalidEmail: false,
    m_invalid: null,
    m_email: null,
    m_serial: null,
    m_customer: null,
    init: function () {
      this.type = window.vsGetQueryParams()['update'] == 1 ? ReguModalType.Update : ReguModalType.Upgrade;
    },
    linkButtonPressed: function () {
      var _this = this;
      this.state = ReguModalStates.Pending;
      fetch(window.vsvars.backendurl + "/api/verify-existing-customer?" + window.vsToQueryString({ "email": this.email , "update": this.type})).then(function (response) {
        return response.json();
      }).then(function (success_obj) {
        _this.state = ReguModalStates.Complete;
      });
    },
    validateButtonPressed: function () {
      this.state = ReguModalStates.Pending;
      this.m_invalid = null;
      var _this = this;
      fetch(window.vsvars.backendurl + "/api/verify-license?" + window.vsToQueryString({ "email": this.m_email, "serial":this.m_serial, "customer":this.m_customer, "update": this.type})).then(function (response) {
        return response.json();
      }).then(function (success_obj) {
        if (success_obj['charge_exists']) {
          _this.state = ReguModalStates.ManualLicenseComplete;
          setTimeout(function () {
            window.location = success_obj['redirect_url']
          }, 2000);
        } else {
          _this.m_invalid = "This license is invalid, please correct it and try again"
          _this.state = ReguModalStates.ManualLicense;
        }
      });
    }
  }
};

window.AlpineProblemReport = function () {
  var maxLength = 500;
  return {
    'Problem': '',
    'Category': '',
    'CharsRemaining': maxLength,
    // Init function
    postInit: function () {
      if (vsGetQueryParams().source == 'vuescan') {
        this.Category = 'problem-report';
      }
    },
    OnTextInput: function () {
      this.CharsRemaining = maxLength - this.Problem.length;
      if (this.CharsRemaining < 0) {
        this.Problem = this.Problem.substring(0, maxLength);
        this.CharsRemaining = 0;
      }
    },
    OnFileChange: function () {
      var _this = this;
      var file = this.$refs.vslog.files[0];
      fr = new FileReader();
      fr.onload = function () {
        if (fr.result.indexOf("VueScan 9") != 0) {
          _this.$refs.vslog.value = "";
          alert("This file is not a valid VueScan.log file. Please attach a valid VueScan.log file.")
        }
      };
      fr.readAsText(file);
    }
  }
}

window.AlpinePurchaseMultiuser = function () {
  return {
    "selected": 0,
  }
}

window.AlpinePurchaseUpdateProgram = function () {
  return {
    init() {
      if (vsGetQueryParams().onetime == '1')
      {
        this.selected = 0;
        this.show_one_time = 0;
      }
      if (vsGetQueryParams().annual == '1')
        this.selected = 1;
      if (vsGetQueryParams().so == '1')
        this.show_one_time = 0;
    },
    "selected": 1,
    "show_one_time": 1
  }
}

// Alpine Component for main purchase page
window.AlpinePurchase = function () {
  return {
    // This is the payment type selection: 0=one-time, 1=monthly, 2=annual
    "selected": 2,

    // This controls which editions are shown: 'all', 'std_only', 'pro_only'
    "edition_filter": 'all',

    // Scanner characteristics (set from Django template)
    "scanner_has_film": false,
    "scanner_capabilities": 0,

    // This is a boolean flag which indicates if we want to hide the Basic Edition
    // This is done for all users unless we know they have a type 1/3 scanner
    "hide_basic": 1,

    // This is a boolean flag which indicates whether the subscription toggle should be displayed or not, initially set to 1 (true)
    // We aren't currently using this option
    "displaySubscriptionToggle": 1,

    // A/B Test flag: Show small one-time boxes underneath subscription options instead of top toggle
    // When true: Hide top toggle, show small boxes. When false: Show top toggle, hide small boxes
    // This is completely orthogonal to edition_filter
    "show_small_onetime_boxes": 0,

    // A/B Test flag: Whether to automatically filter editions based on scanner characteristics
    // When true: Show only std/pro editions based on scanner type. When false: Always show all editions
    "show_std_or_pro_only": 0,

    // A/B Test flag: Show per year text for annual subscription
    "show_per_year_text": 0,

    // A/B Test Flag: Show "Buy Now" vs "Buy w/ Card and Subscribe w/ card"
    "show_buy_now": 0,

    // A/B Test Flag: Show information in feature list about the subscription
    "show_subscription_info": 0,

    // A/B Test Flag: Social Proof Section
    "show_social_proof": 0,

    // A/B Test Flag: Review Site Section
    "show_reviewsite": "",

    // A/B Test Flag: Hide one-time option
    "hide_onetime": 0,

    // A/B Test Flag: Show monthly option in toggle
    "show_monthly": 0,

    // This is the frequency of the subscription, initially set to 1 (annual)
    "freq": 1,

    // Init function
    postInit: function () {
      // Handle basic edition
      if (vsGetQueryParams().basic == '1') {
        this.selected = 0;
        this.hide_basic = 0;
      }
      
      // A/B Test: Check for show_std_or_pro_only parameter
      if (vsGetQueryParams().show_std_or_pro_only == '0') {
        this.show_std_or_pro_only = 0;
      } else if (vsGetQueryParams().show_std_or_pro_only == '1') {
        this.show_std_or_pro_only = 1;
      }
      
      // Handle edition filters - can be set by URL params or scanner characteristics
      if (vsGetQueryParams().pro_only == '1') {
        this.edition_filter = 'pro_only';
      } else if (vsGetQueryParams().std_only == '1') {
        this.edition_filter = 'std_only';
      } else if (vsGetQueryParams().all == '1') {
        this.edition_filter = 'all';
      }
      // If no explicit filter is set AND show_std_or_pro_only is enabled, use scanner characteristics to determine default
      else if (this.show_std_or_pro_only && this.scanner_has_film) {
        this.edition_filter = 'pro_only';
      } else if (this.show_std_or_pro_only && this.scanner_capabilities != 0 && !this.scanner_has_film) {
        this.edition_filter = 'std_only';
      }
      // Otherwise, default to showing all editions
      else {
        this.edition_filter = 'all';
      }
      
      // Handle payment type selection
      if (vsGetQueryParams().annual == '1') {
        this.selected = 2;
      } else if (vsGetQueryParams().subscription == '1') {
        this.selected = 1;
      } else if (vsGetQueryParams().onetime == '1') {
        this.selected = 0;
      }

    },

    // This function scrolls to the top of the page and shows all editions
    showAllEditions: function () {
      this.edition_filter = 'all';
      this.selected = 2; // Default to annual when showing all
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    // Helper function to determine which one-time box to show in A/B test
    shouldShowStandardOneTime: function () {
      return this.show_small_onetime_boxes && (this.edition_filter == 'all' || this.edition_filter == 'std_only');
    },

    shouldShowProfessionalOneTime: function () {
      return this.show_small_onetime_boxes && (this.edition_filter == 'all' || this.edition_filter == 'pro_only');
    },

    // This function scrolls to the top of the page. It's used when the user selects the option to display all editions, not just Professional
    scrollToTop: function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}

// Alpine Component for main purchase page
window.AlpineSupporterPurchase = function (currency) {
  if (!(currency == 'USD' || currency == 'GBP' || currency == 'EUR'))
    currency = 'USD';

  return {
    "subscription_selected": 1,
    "dropdown_show": 0,
    "price_index": 3,
    "currency": currency,
    "formatted_prices": {
      "USD": ["$100", "$50", "$40", "$30", "$20", "$10"],
      "EUR": ["€100", "€50", "€40", "€30", "€20", "€10"],
      "GBP": ["£100", "£50", "£40", "£30", "£20", "£10"]
    },
    "unformatted_prices": {
      "USD": ["100.00", "50.00", "40.00", "30.00", "20.00", "10.00"],
      "EUR": ["100.00", "50.00", "40.00", "30.00", "20.00", "10.00"],
      "GBP": ["100.00", "50.00", "40.00", "30.00", "20.00", "10.00"]
    },
    price_ids: {
      "USD": [
        // One time
        ['price_1QXjzdEhg6foNxJiN04oYPmt', 'price_1OHwSxEhg6foNxJiZqyAKqAE','price_1OGpEEEhg6foNxJitUnie3oc','price_1OHqU3Ehg6foNxJiM5q7Zgzo','price_1OHqUAEhg6foNxJibQjXc94s','price_1OHqUIEhg6foNxJiOXYz2wDJ'],
        // Subscription
        ['price_1QXk1jEhg6foNxJik7nSIghv', 'price_1OHwV0Ehg6foNxJi9LqSHb85','price_1OH3yuEhg6foNxJi1p5JFQnC','price_1OHqd1Ehg6foNxJibX4f2nsr','price_1OHqdAEhg6foNxJi8e5kleQ7','price_1OHqdIEhg6foNxJiw1hxmd4u'],
      ],
      "EUR": [
        // One time
        ['price_1QXjzpEhg6foNxJi1jfC12nt', 'price_1OHwTCEhg6foNxJice3w3apJ','price_1OHqV6Ehg6foNxJiSYVwVIDt','price_1OHqVDEhg6foNxJiMPah0jzC','price_1OHqVKEhg6foNxJiYPONhnO0','price_1OHqVSEhg6foNxJicPfdatRx'],
        // Subscription
        ['price_1QXk1vEhg6foNxJipuXO1W6Y', 'price_1OHwV9Ehg6foNxJiDtcJH9vW','price_1OHqfJEhg6foNxJiAWiGTpaH','price_1OHqfUEhg6foNxJiLo8aLDgR','price_1OHqfhEhg6foNxJi4riSG7TY','price_1OHqg3Ehg6foNxJigajxWUT9'],
      ],
      "GBP": [
        // One time
        ['price_1QXk03Ehg6foNxJizBaIrzq7', 'price_1OHwT5Ehg6foNxJiPlBL7HIY','price_1OHqWBEhg6foNxJisGEzh2TH','price_1OHqWKEhg6foNxJiZBNGdkYG','price_1OHqWREhg6foNxJiW87Na0zR','price_1OHqWbEhg6foNxJiF20xldSv'],
        // Subscription
        ['price_1QXk27Ehg6foNxJiSHz9OuR1', 'price_1OHwVJEhg6foNxJipPbzGWUJ','price_1OHqgSEhg6foNxJiKvh7m70a','price_1OHqgcEhg6foNxJiRDWOThGH','price_1OHqgoEhg6foNxJitXnKwU3K','price_1OHqh2Ehg6foNxJiKvSKTlwe'],
      ]
    },
    test_price_ids: {
      "USD": [
        // One time
        ['price_1QXk4cEhg6foNxJi0eNKJgQ6', 'price_1OHwK5Ehg6foNxJixP7mSFNp','price_1OGpDFEhg6foNxJiq4MBig9I','price_1OHpXtEhg6foNxJip6TzgKkp','price_1OHpgYEhg6foNxJiKALGsVSy','price_1OHph1Ehg6foNxJiZklcWKGM'],
        // Subscription
        ['price_1QXk6iEhg6foNxJiqwHXBjKj', 'price_1OHwRMEhg6foNxJiihG1ism3','price_1OH408Ehg6foNxJiSGmPkz9N','price_1OHpjrEhg6foNxJics1RWIBn','price_1OHpk2Ehg6foNxJihe4UwkGH','price_1OHpkAEhg6foNxJis33IyMYU'],
      ],
      "EUR": [
        // One time
        ['price_1QXk4mEhg6foNxJiUeGotjpD', 'price_1OHwKWEhg6foNxJi5IoN8UAd','price_1OHqN2Ehg6foNxJiUTx79Jm9','price_1OHqNEEhg6foNxJittpIhLZN','price_1OHqNNEhg6foNxJiSOiB3FMl','price_1OHqNrEhg6foNxJiJn4S5WPY'],
        // Subscription
        ['price_1QXk6wEhg6foNxJiOFVYFt5U', 'price_1OHwRYEhg6foNxJiYerBQVYr','price_1OHpvjEhg6foNxJi2Cu366uZ','price_1OHpw2Ehg6foNxJiiEtZuKud','price_1OHpwQEhg6foNxJiL7XpJZ45','price_1OHpwfEhg6foNxJibS8IlLnP'],
      ],
      "GBP": [
        // One time
        ['price_1QXk5ZEhg6foNxJi8vL1gupf', 'price_1OHwKlEhg6foNxJiGh3p673X','price_1OHqO0Ehg6foNxJiP6jn0VA7','price_1OHqO9Ehg6foNxJiAgPsB4Ra','price_1OHqOIEhg6foNxJi1VXphXRx','price_1OHqOSEhg6foNxJi0keb6B2q'],
        // Subscription
        ['price_1QXk78Ehg6foNxJiXYZDmtzc', 'price_1OHwRhEhg6foNxJiE1k5y3oW','price_1OHpwuEhg6foNxJidtBvWgop','price_1OHpxAEhg6foNxJioPPanpHw','price_1OHpxSEhg6foNxJiQKvUAdCn','price_1OHpxtEhg6foNxJiqH78EHei'],
      ]
    },
    init() {
      if (vsGetQueryParams().onetime == '1')
        this.subscription_selected = 0;
      if (vsGetQueryParams().annual == '1')
        this.subscription_selected = 1;
      if (vsGetQueryParams().i) {
        index = parseInt(vsGetQueryParams().i, 10);
        if (!isNaN(index) && index >= 0 && index <= 3) {
          this.price_index = index;
        }
      }
      this.$nextTick(vsPaypalLoadButtons);
    },
    choose_amount_url () {
      if (vsGetQueryParams().test) {
        if (this.currency == 'GBP')
          return 'https://buy.stripe.com/test_00g4hw70G85LduE146'
        else if (this.currency == 'EUR')
          return 'https://buy.stripe.com/test_3cs3ds1Gmeu99eoaEF'
        else
          return 'https://buy.stripe.com/test_00g7tI70G2Lr62ceUU';
      } else {
        if (this.currency == 'GBP')
          return 'https://buy.stripe.com/28o3d3anA9fWcXm6os'
        else if (this.currency == 'EUR')
          return 'https://buy.stripe.com/5kA4h78fs8bS6yY8wz'
        else
          return 'https://buy.stripe.com/eVa6pfdzMak0f5u9AC';
      }
    }
  }
}

const EmailModalStates = Object.freeze({
  Main: 1,
  Pending: 2,
  Complete: 3
});

const EmailModalTextStates = Object.freeze({
  Mobile: 1,
  LiDE: 2
});
window.EmailModalStates = EmailModalStates;
window.EmailModalTextStates = EmailModalTextStates;

window.AlpineEmailModal = function () {
  return {
    state: EmailModalStates.Main,
    email: null,
    invalidEmail: false,
    ExistingCustomer: false,
    init: function () {
    },
    // From https://stackoverflow.com/a/46181
    validateEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    linkButtonPressed: function () {
      if (this.validateEmail(this.email)) {
        this.invalidEmail = false;
        this.submitPost.call(this);
      } else {
        this.invalidEmail = true;
      }
    },
    submitPost: function () {
      this.state = EmailModalStates.Pending;
      emailData = JSON.parse(localStorage.getItem("vsDownloadPageStatObj")) || vsGetStatObj();
      emailData['email'] = this.email;
      emailData['ExistingCustomer'] = this.ExistingCustomer ? 1 : 0
      var _this = this;
      fetch(window.vsvars.backendurl + "/api/lead-register?" + window.vsToQueryString(emailData)).then(function (response) {
        return response.json();
      }).then(function (success_obj) {
        _this.state = EmailModalStates.Complete;
        localStorage.setItem('vsLeadID', success_obj['LeadID']);
        
        // Track email capture completion for A/B test
        if (window.vsFeatureFlags && window.vsFeatureFlags.emailDownloadVariation) {
          var trackingObj = vsGetStatObj();
          trackingObj.ABTestEvent = '2025-06-20-email-download:email_capture_completed';
          trackingObj.ABTestVariation = window.vsFeatureFlags.emailDownloadVariation;
          trackingObj.email = _this.email;
          trackingObj.LeadID = success_obj['LeadID'];
          if (!vsIsLocal()) {
            vsJSONP("https://stats.hamrick.com/v1/stat", null, trackingObj);
          }
        }
        
        isMobile = scannerInfo.osString == 'Mobile';
        if (!isMobile) {
          setTimeout(function () {
            window.location = window.vsvars.baseurl + "/download.html?dl=1";
          }, 1000)
        }
      });
    }
  }
}

// document.addEventListener('alpine:init', () => {
//   Alpine.store('AlpineSearch', AlpineSearch);
// })

window.AlpineNavbar = function () {
  const language_map = {
    "en": "English",
    "de": "Deutsch",  
    "fr": "Français",
    "es": "Español",
    "it": "Italiano",
    "ru": "Русский",
    "ja": "日本語",
    "zh": "中文 (简体)",
    "tw": "中文 (繁體)",
    "ko": "한국어"
  }

  return {
    open: false, 
    lang: document.querySelector('html').lang || 'en',
    languagemenu: false,
    hreflangs: [],
    init: function () {
      this.hreflangs = Array.prototype.map.call(document.querySelectorAll("link[rel='alternate']"), function (alt) {
        let hreflang = {
          "href": alt.getAttribute('href'),
          "code": alt.getAttribute('hreflang')
        };
        hreflang["lang"] = language_map[hreflang['code']];
        return hreflang;
      }).filter(hreflang => hreflang['code'].length == 2);
    },
    url: function (href) {
      if (['de','fr'].indexOf(this.lang) > -1)
        return "/"+this.lang+href
      else
        return href
    },
  }
}

window.AlpineDownloadPage = function () {
  return {
    installurl: null,
    os: 'MacOS',
    browser: 'Safari',
    init: function () {
      let isApple = !!navigator.userAgent.match(/(Mac|iPhone|iPod|iPad)/i);
      let isWindows = !!navigator.userAgent.match(/(Win32|Win64|Windows|WinCE)/);
      let isLinux = !isApple && !isWindows && !!/Linux/.test(navigator.userAgent);
      var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
      var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
      var is_edge = navigator.userAgent.indexOf('Edg') > -1;

      if (isLinux)
      {
        this.os = 'Linux';
        this.browser = 'Chrome';
      }
      else if (isApple)
      {
        this.os = 'MacOS';
        if (is_chrome)
          this.browser = 'Chrome';
        else if(is_firefox)
          this.browser = 'Firefox';
        else
          this.browser = 'Safari';
      }
      else
      {
        this.os = 'Windows';
        if (is_chrome && !is_edge)
          this.browser = 'Chrome';
        else if(is_firefox)
          this.browser = 'Firefox';
        else
          this.browser = 'Edge';
      }


      if (isApple)
        this.installurl = window.vsvars.baseurl + '/support/how-to-guides/how-to-install-vuescan-on-mac-os-x.html';
      else
        this.installurl = window.vsvars.baseurl + '/support/how-to-guides/how-to-install-vuescan-on-windows.html';
      
      if (window.vsGetQueryParams()['onboard'] == 1)
        this.$nextTick(() => window.Alpine.$data(document.querySelector("#AlpineTutorialModal")).open = true)
    },
    tutorialButtonClicked: function () {
      Alpine.$data(document.querySelector("#AlpineTutorialModal")).open = true;
    }
  }
}

window.AlpineOnboardFull = function () {
  return {
    modalopen: false,
    init: function () {
      // Automatically open the modal and load partial view
      this.$nextTick(() => window.Alpine.$data(document.querySelector("#AlpineTutorialModal")).open = true)
      // Watch modalopen and if it closes redirect to index page
      this.$watch('modalopen', (modalopen) => {
        if(!modalopen)
        {
          // If the modal closes, reopen it immediately incase the user selects the back button, we want it to stay open
          this.modalopen=true;
          document.location = window.vsvars.baseurl + '/support/how-to-guides';
        }
      });
    }
  }
}

window.AlpineTutorialModal = function () {
  return {
    open: false,
    init: function () {
      this.$watch('open', (open) => {
        this.$dispatch('load-onboarding-view')
      });
    }
  }
}

window.AlpineOnboardView = function (pageCount) {
  return {
    pageCount: pageCount,
    platform: null,
    screen: 1,
    init: function () {
      this.platform = !!navigator.userAgent.match(/(Mac|iPhone|iPod|iPad)/i) ? 'MacOS' : 'Windows'
      this.$watch('open', (open) => {
        this.screen = 1
      });
    },
    close: function () {
      this.open = false;
    },
    nextPage : function () {
      this.screen++
      if (this.screen > this.pageCount)
        this.screen = 1;
    },
    previousPage: function () {
      this.screen-- ;
      if (this.screen < 1)
        this.screen = 1
    }
  }
}

window.AlpineVendorList = function (showVendorList) {
  showVendorList = showVendorList || false;
  return {
    init: function () {
      if (window.location.hash == '#scanner-drivers') {
        this.showVendorList = true;
      }
    },
    showVendorList: showVendorList
  }
}

window.vs_replace_blank_target_links = function() {
  var links = document.querySelectorAll('a[target="_blank"], a[target="_top"]');
  for (var i = 0; i < links.length; i++) {
    var link = links[i];
    var href = link.getAttribute('href');
    if (link.hasAttribute('data-original-url')) {
      href = link.getAttribute('data-original-url');
    }

    var queryParams = vsGetQueryParams();
    var queryString = '';
    
    // Parse existing URL parameters if any
    var existingParams = vsGetQueryParamsFromUrl(href);
    
    // Only add parameters that don't already exist in the URL
    var paramsToAdd = {};
    Object.keys(queryParams).forEach(function(key) {
      if (!existingParams.hasOwnProperty(key)) {
        paramsToAdd[key] = queryParams[key];
      }
    });
    
    // Build query string with new parameters
    queryString = Object.keys(paramsToAdd).map(function(key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(paramsToAdd[key]);
    }).join('&');
    
    if (queryString) {
      href += (href.includes('?') ? '&' : '?') + queryString;
    }


    link.removeAttribute('target');
    var extraJS = '';
    if (link.hasAttribute('data-close')) {
      extraJS = "; setTimeout(function() { vs_send_event('CloseModal') }, 500)";
    }

    link.setAttribute('href', "javascript:vs_open_external_url('" + href + "') " + extraJS + ' //');
  }
}

window.vs_open_external_url = function(url) {
    window.vs_send_event('OpenExternalURL', { 'URL': url });
}

window.vs_send_problem_report = function() {
  window.vs_send_event('VSProblemReport');
}

window.vs_send_event = function(action_name, args) {
    var obj = {
        "ActionName": action_name
    }
    if (args && typeof args === 'object' && !Array.isArray(args) && Object.keys(args).length > 0) {
        for (var key in args) {
            if (args.hasOwnProperty(key)) {
                obj[key] = args[key];
            }
        }
    }

    var queryString = Object.keys(obj).map(function(key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
    }).join('&');
    window.location.href = "vuescan://action?" + queryString;

    // window.wx.postMessage(JSON.stringify(obj), '*');
    // window.postMessage(JSON.stringify(obj), '*');
}

// Add global HTMX event handler for query parameters
document.body.addEventListener('htmx:configRequest', function(event) {
  // Only add query params if they're not already specified
  if (!event.detail.parameters || !event.detail.parameters.vsGetQueryParams) {
    event.detail.parameters = {
      ...event.detail.parameters,
      ...vsGetQueryParams()
    };
  }
});

// Function to check if we're on Google Translate
function vs_is_translated() {
  return window.location.href.includes('translate.goog');
}

// Function to disable HTMX on Google Translate for troubleshooting pages
function vs_disable_htmx_on_translate() {
  if (vs_is_translated()) {
    const myElement = document.getElementById('vss-main');
    if (myElement) {
      myElement.setAttribute("hx-disable", "");
      htmx.process(myElement);
    }
  }
}

// Call both functions when the page loads
document.addEventListener('DOMContentLoaded', function() {
  vs_disable_htmx_on_translate();
});

